/** @prettier */

import {Dialog, DialogTitle, DialogContent, DialogActions} from '@mui/material';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Auth} from 'aws-amplify';
import {useNavigate} from 'react-router-dom';

//MTH component import
import APIErrorMessage from './DeleteAccountAPIErrorMessage';
//API import
import {deleteSettingUser} from '../../API/API_Collection';

import {PrimaryButton, SecondaryButton} from '../../component/BasicButton';

/**
 * アカウント削除確認ダイアログ
 * @param props props
 * - isOpenDeleteDialog アカウント削除確認ダイアログ開閉
 * - setIsOpenDeleteDialog アカウント削除確認ダイアログ開閉設定関数
 * - emailAddr ダイアログに表示するためのメールアドレス
 * @returns JSX
 */
const DeleteDialog = (props: {
  isOpenDeleteDialog: boolean;
  setIsOpenDeleteDialog: React.Dispatch<React.SetStateAction<boolean>>;
  emailAddr: string;
}) => {
  const [errorCode, setErrorCode] = useState(''); //削除失敗時のcode格納用変数
  const [errorParam, setErrorParam] = useState(''); //削除失敗時のparameter格納用変数
  const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false); //削除失敗時のエラーメッセージ表示
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ
  const trans = useTranslation().t; //翻訳関数
  const navigate = useNavigate();

  /**
   * OKボタン押下時処理
   */
  const deleteUser = () => {
    setAPIWait(true);
    setErrorCode('');

    deleteSettingUser()
      .then(() => {
        //API完了後、画面遷移
        Auth.signOut().then(() => {
          //サインアウトしたらログイン画面に遷移
          //ログイン画面のパス「routeList.login.path」にすると遷移しないため、「window.location.host」を使用している
          navigate(window.location.host);
        });
      })
      .catch((error: any) => {
        //statusCodeがFORBIDDENの場合はエラー表示を切り替える
        setAPIWait(false);
        setIsOpenErrorDialog(true);
        setErrorCode(error.response.data.code);
        setErrorParam(error.response.data.parameter);
      });
  };
  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    props.setIsOpenDeleteDialog(false);
  };

  return (
    <>
      <Dialog
        open={props.isOpenDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id={`mv-delAccountDialog`}>
        <DialogTitle id="alert-dialog-title">
          {trans('DeleteAccountDialog.title')}
        </DialogTitle>
        <DialogContent>
          <div>
            {trans('DeleteAccountDialog.email')}
            &nbsp;:&nbsp;
            {props.emailAddr}
          </div>
          <p id="alert-dialog-description">
            {trans('DeleteAccountDialog.msg')}
          </p>
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            disabled={apiWait}
            onClick={handleClose}
            buttonText={trans('DeleteAccountDialog.buttonTxt.cancel')}
            id={'mv-delAccountBtnCancel'}
          />
          <PrimaryButton
            onClick={deleteUser}
            buttonText={trans('DeleteAccountDialog.buttonTxt.ok')}
            id={`mv-delAccountBtnOK`}
            disabled={apiWait}
            className="btnOK"
            apiWait={apiWait}
          />
        </DialogActions>
      </Dialog>
      <APIErrorMessage
        deleteAccountErrorOpen={isOpenErrorDialog}
        setDeleteAccountErrorOpen={setIsOpenErrorDialog}
        id={`mv-delAccountBtnErrDlg`}
        errorCode={errorCode}
        errorParam={errorParam}
      />
    </>
  );
};
export default DeleteDialog;
